import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './layout.component.html',
    imports: [RouterOutlet]
})
export class LayoutComponent { }
